import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE = '/api/impersonations';

export default {
    // Sin .catch propio: el componente necesita leer el mensaje de error real
    // (ej. "No se puede impersonar a otro Super Admin") en vez de un genérico.
    start(targetType, targetId) {
        return Api().post(RESOURCE, { targetType, targetId });
    },
    stop() {
        return Api().delete(`${RESOURCE}/current`)
            .catch((err) => errorHandler(err, null));
    },
}
